module.exports={accessToken:{production:"175cd20d384fc601d7054568dd98819a",development:"a0060de8c3c86ddaedb082df4e29bb5e"}};